import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { SignUpPage } from "@/pages"

const signupSearchSchema = z.object({
  inviteCode: z.string().uuid().optional(),
  return: z.string().optional(),
})

export const Route = createFileRoute("/_unauthenticated/signup")({
  component: SignUpPage,
  validateSearch: signupSearchSchema,
})
